import React from "react";
import ImagePlaceholderSVG from "./shared/svg/ImagePlaceholder";

interface TimelineItemProps {
    title: string;
    description: string;
    stageDateTime?: string;
    imageUrl?: string;
    index: number;
}

export default function TimelineItem({ title, description, stageDateTime, imageUrl }: TimelineItemProps) {
    return (
        <div className="flex flex-col lap:flex-row w-full relative gap-[24px] xl:gap-[34px]">
            <div className="flex-1 flex flex-col lap:pr-8 ml-[16px] md:ml-[32px] lap:ml-0">
                <div className="max-w-[605px] w-full">
                    <h3 className="font-medium text-xl uppercase text-primary-400">
                        {stageDateTime ? `${stageDateTime} - ${title}` : title}
                    </h3>
                    <p className="font-normal text-base text-text-300 mt-3 whitespace-normal break-words">{description}</p>
                </div>
                <div className="mt-4 lap:hidden">
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={title}
                            className="w-full h-[300px] object-cover rounded-[6px]"
                        />
                    ) : (
                        <div className="w-full h-[300px] bg-gray-100 rounded-[6px] flex items-center justify-center">
                            <ImagePlaceholderSVG fill="#bec6d5" classname="w-20 h-20" />
                        </div>
                    )}
                </div>
            </div>
            <div className="hidden lap:flex flex-1 items-start ml-[32px]">
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt={title}
                        className="w-full max-w-[605px] h-[280px] object-cover rounded-[6px]"
                    />
                ) : (
                    <div className="w-full max-w-[605px] h-[280px] bg-gray-100 rounded-[6px] flex items-center justify-center">
                        <ImagePlaceholderSVG fill="#bec6d5" classname="w-20 h-20" />
                    </div>
                )}
            </div>
        </div>
    );
}
